import * as React from 'react'

// import { Button } from 'antd'
import styles from './index.module.scss'

interface Props {
  filterForm: any
  filterData: any
  handleChangeSort?: Function | undefined
  label?: any
}

const SortBy: React.FunctionComponent<Props> = (props?: any) => {
  const { filterForm, filterData, handleChangeSort, label } = props

  React.useEffect(() => {
    const all = [...filterData.orderSelect].concat([
      { value: '2', label: 'Price High - Low' },
      { value: '3', label: 'Price Low - High' }
    ])
    const active = all.find((item) => item.value === filterForm.order) ?? {}
    label && (label.current = active.label)
  }, [filterForm, filterData])

  return (
    <div className={styles['products-sortby']}>
      <div className={styles['product-filter']}>
        <div className={styles['sort-by']}>Sort By</div>
        <div className={styles['sort-list']}>
          {filterData.orderSelect?.map((s: any) => {
            return (
              <div
                key={s.value}
                className={`${styles['sort-item-btn']} ${
                  filterForm.order === s.value ? styles['active'] : ''
                }`}
                onClick={() => handleChangeSort(s.value, s.label)}
              >
                {s.label}
              </div>
            )
          })}
          <div
            className={`${styles['sort-item-btn']} ${styles['price-btn']} ${
              ['2', '3'].includes(filterForm.order) ? styles['active'] : ''
            }`}
            onClick={() => handleChangeSort('price', 'price')}
          >
            Price
            <div className={styles['price-up-down']}>
              <i
                className={`iconfont icon-xiala ${
                  filterForm.order === '3' ? styles['price-active'] : null
                }`}
              ></i>
              <i
                className={`iconfont icon-xiala ${
                  filterForm.order === '2' ? styles['price-active'] : null
                }`}
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SortBy
